import clsx from "clsx";
import PropTypes from "prop-types";
import { forwardRef, useMemo } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { buttonTracking } from "@lib/tracking.helpers";

import "./list-item.scss";

export const ListItem = forwardRef(
  (
    {
      children,
      className,
      disabled,
      index,
      onClick,
      icon,
      interactive = true,
      role = "button",
    },
    ref,
  ) => {
    const listItemIcon = useMemo(() => {
      if (icon === false) {
        return;
      }

      return icon ?? <FontAwesomeIcon icon={["fa-regular", "angle-right"]} />;
    }, [icon]);

    const Body = interactive ? "button" : "div";
    const bodyProps = interactive
      ? {
          role,
          onClick,
          disabled,
          ...buttonTracking("list-item", index, children),
        }
      : {};

    return (
      <div
        className={clsx(
          "list-item-container",
          { "list-item-container-no-index": index === undefined },
          className,
        )}
      >
        <Body ref={ref} className="list-item-body" {...bodyProps}>
          {index !== undefined && (
            <div className="list-item-index">
              <span>{index}</span>
            </div>
          )}
          <div className="list-item-content">{children}</div>
        </Body>
        <div className="list-item-icon">{listItemIcon}</div>
      </div>
    );
  },
);

ListItem.displayName = "List Item";

ListItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onClick: PropTypes.func,
  interactive: PropTypes.bool,
  role: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
};
